import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default class ArcGisLocationDisplay extends React.Component {
    render() {
        const { arcGisLocation, location, makeLink } = this.props;

        const suppliedEntity = arcGisLocation || location;

        const encodedAddrLoc =
            makeLink && suppliedEntity && suppliedEntity.addrLoc
                ? encodeURIComponent(suppliedEntity.addrLoc)
                : null;

        return (
            <div className="d-flex">
                {!makeLink && (
                    <div className="mr-1">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </div>
                )}

                <div>
                    {!suppliedEntity && <>Location not available.</>}

                    {Boolean(
                        (!makeLink && suppliedEntity) ||
                        (makeLink && !encodedAddrLoc)
                    ) && <div>{suppliedEntity.addrLoc}</div>}

                    {Boolean(makeLink && encodedAddrLoc) && (
                        <div>
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-2"
                                title="Open in Google Maps"
                                href={`https://www.google.com/maps/place/${encodedAddrLoc}`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />{' '}
                                {suppliedEntity.addrLoc}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
